// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LH-z","twoColumnImage":"MH-z"};